import { CaretRight } from "@phosphor-icons/react";
import { useState } from "react";

import { LinkedInLoginModal } from "common/components/LinkedInLogin";
import RestrictedComponent from "common/components/RestrictedComponent";
import { Button } from "common/components/ui/Button";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

export default function ConnectAccount() {
  const isDesktop = useTwBreakpoint("lg");
  const [isOpen, setIsOpen] = useState(false);

  return (
    <RestrictedComponent visibleForPermissions={["accounts_full"]}>
      <Button
        onClick={() => setIsOpen(true)}
        size="sm"
        rightIcon={isDesktop && <CaretRight />}
        intent={isDesktop ? "default" : "iconOnly"}
      >
        {isDesktop ? "Connect account" : <CaretRight />}
      </Button>
      <LinkedInLoginModal isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </RestrictedComponent>
  );
}
